import { useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";

import { appendSolarColumns, getTableHeaders } from "../../tableHeaders";
import { BuildingsTable } from "../../../demo/components/BuildingsTable";

export const DataTab = ({ buildings }) => {
  const { clusters } = useSelector((state) => state.auth);

  return (
    <>
      <Box mt={5.5} display="flex" justifyContent="space-between">
        <Typography variant="h1">Data</Typography>
      </Box>
      <BuildingsTable
        rows={buildings}
        headers={appendSolarColumns(
          clusters[0].preliminary_stage,
          getTableHeaders(clusters[0].preliminary_stage)
        )}
        disableTable
      />
    </>
  );
};
